'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var AppConfig = {
	msClientId: '88704920-3119-473b-b5f4-219639c48419',
	apiServiceBaseUri: 'http://localhost:30641/'
};

exports.default = AppConfig;


// WEBPACK FOOTER //
// ./CarsNowAppConfig.js